module.exports = __webpack_public_path__ + "static/media/build.214aecaf.svg";